module.exports = __webpack_public_path__ + "img/login_bg.d908dc07.jpg";